export default {
  brand: "A&A MOTORS",
  tagline: "КАЖДАЯ ПОЕЗДКА. КАЖДЫЙ СТИЛЬ ЖИЗНИ.",
  slogan: "ВСЕ АВТО. ВСЕ СТИЛИ. ОДНО ИМЯ.",
  nav: {
    fleet: "Автопарк",
    noDeposit: "Без депозита",
    how: "Как это работает",
    about: "О нас",
    faq: "Вопросы",
    contact: "Контакты",
    book: "Забронировать",
    menu: "Меню",
    close: "Закрыть",
  },
  hero: {
    eyebrow: "Аренда авто в Дубае",
    line1: "КАЖДАЯ ПОЕЗДКА.",
    line2: "КАЖДЫЙ СТИЛЬ ЖИЗНИ.",
    sub: "От повседневных поездок до незабываемых впечатлений.",
    ctaFleet: "Смотреть автопарк",
    ctaBook: "Забронировать",
    scroll: "Листайте",
  },
  categories: {
    all: "Все автомобили",
    economy: "Эконом",
    everyday: "На каждый день",
    sedans: "Седаны",
    suv: "Внедорожники",
    luxury: "Люкс",
    sports: "Спорткары",
    supercars: "Суперкары",
  },
  fleet: {
    eyebrow: "Коллекция",
    title: "Наш автопарк",
    sub: "Наш актуальный автопарк — скоро появятся новые автомобили. Наличие и цены подтверждаются по запросу.",
    priceOnRequest: "Цена по запросу",
    perDay: "/ день",
    seats: "Мест",
    transmission: "Коробка",
    viewDetails: "Подробнее",
    enquire: "Отправить запрос",
    noDeposit: "Без депозита",
    onRequest: "По запросу",
    available: "Доступен",
    unavailable: "Недоступен",
    sort: "Сортировка",
    sortFeatured: "Рекомендуемые",
    sortName: "По имени А–Я",
    sortPriceAsc: "Цена: по возрастанию",
    sortPriceDesc: "Цена: по убыванию",
    noDepositOnly: "Без депозита",
    showAll: "Показать все",
    noResults: "Нет автомобилей по этому фильтру.",
    sampleNote: "Наличие, характеристики и итоговая цена всегда подтверждаются нашей командой до бронирования.",
    loading: "Загрузка автопарка…",
    loadError: "Не удалось загрузить автопарк. Попробуйте ещё раз.",
    retry: "Повторить",
  },
  modal: {
    specs: "Характеристики",
    engine: "Двигатель",
    acceleration: "0–100 км/ч",
    perDay: "в день",
    finalNote: "Итоговая цена и наличие подтверждаются по запросу.",
    noDepositYes: "Доступна аренда без депозита (условия применяются)",
    enquireVehicle: "Запросить это авто",
    whatsapp: "WhatsApp",
    close: "Закрыть",
    drag: "Тяните для вращения",
    gallery: "Галерея",
    view360: "Обзор 360°",
    fullscreen: "Полный экран",
    exitFullscreen: "Выйти из полного экрана",
    availability: "Наличие",
    previous: "Предыдущее фото",
    next: "Следующее фото",
  },
  nodeposit: {
    eyebrow: "Гибкая аренда",
    title: "ДОСТУПНА АРЕНДА БЕЗ ДЕПОЗИТА",
    text: "Более гибкие условия аренды в Дубае. Аренда без депозита доступна для отдельных автомобилей и зависит от условий, таких как срок аренды и профиль водителя.",
    cta: "Авто без депозита",
    note: "Действует только для отдельных автомобилей. Условия подтверждаются при запросе.",
  },
  how: {
    eyebrow: "Процесс",
    title: "Как это работает",
    steps: [
      { t: "Выберите автомобиль", d: "Изучите нашу коллекцию — от повседневных авто до люкса и суперкаров." },
      { t: "Отправьте запрос", d: "Укажите желаемый автомобиль и даты аренды." },
      { t: "Подтвердите бронирование", d: "Наша команда подтвердит наличие, цену, требования и следующие шаги." },
    ],
  },
  about: {
    eyebrow: "Об A&A MOTORS",
    title1: "БОЛЬШЕ, ЧЕМ АВТОМОБИЛЬ.",
    title2: "ЭТО ВАШ СТИЛЬ ЖИЗНИ.",
    p1: "В A&A MOTORS мы верим: каждая поездка заслуживает правильного автомобиля.",
    p2: "Исследуете Дубай, едете по делам, ищете комфортный автомобиль на каждый день или готовы к спорткару — наша цель сделать выбор следующей поездки простым и гибким.",
    p3: "От повседневных решений до ярких автомобильных впечатлений мы строим бренд вокруг выбора, сервиса и свободы ездить по-своему.",
  },
  trust: {
    eyebrow: "Доверие и прозрачность",
    title: "Аренда с уверенностью",
    items: [
      { t: "Прозрачные условия", d: "Все условия предоставляются письменно до подтверждения." },
      { t: "Честные цены", d: "Без скрытых платежей — итоговая цена подтверждается при запросе." },
      { t: "Депозит по автомобилю", d: "Депозит или аренда без него зависят от выбранного автомобиля." },
      { t: "Быстрая поддержка", d: "Мы на связи в WhatsApp и по телефону — на вашем языке." },
      { t: "Простые запросы", d: "Одна форма или одно сообщение — остальное сделает наша команда." },
    ],
  },
  faq: {
    eyebrow: "Полезно знать",
    title: "Частые вопросы",
    items: [
      {
        q: "Какие документы нужны для аренды авто в Дубае?",
        a: "Обычно: действующие водительские права, паспорт или Emirates ID и банковская карта. Туристам может потребоваться международное водительское удостоверение в зависимости от страны выдачи прав. Точные требования зависят от автомобиля и статуса пребывания — мы подтверждаем всё до бронирования.",
      },
      {
        q: "Нужен ли паспорт?",
        a: "От туристов обычно требуется паспорт с отметкой о въезде или визой; резиденты ОАЭ используют Emirates ID. Требования различаются, и мы подтверждаем их для каждого бронирования.",
      },
      {
        q: "Обязательны ли действующие права?",
        a: "Да, всегда. В зависимости от страны выдачи может понадобиться международное удостоверение. Для некоторых мощных автомобилей действуют требования к возрасту и стажу.",
      },
      {
        q: "Есть ли аренда без депозита?",
        a: "Да, для отдельных автомобилей и на определённых условиях. Возможность зависит от автомобиля, срока аренды и профиля водителя — уточните у нас по конкретному авто.",
      },
      {
        q: "Можно ли арендовать авто на один день?",
        a: "Да, посуточная аренда доступна для многих автомобилей; для отдельных моделей может действовать минимальный срок.",
      },
      {
        q: "Можно ли заказать доставку в отель?",
        a: "Доставка по Дубаю — в отель, резиденцию или аэропорт — возможна по запросу, в зависимости от автомобиля и расписания.",
      },
      {
        q: "Как проверить наличие автомобиля?",
        a: "Отправьте запрос через форму или WhatsApp с вашими датами — команда подтвердит наличие и точную цену до бронирования.",
      },
      {
        q: "Какие условия аренды и страхования?",
        a: "Базовая страховка обычно включена. Франшиза, лимит пробега, топливо и сборы Salik зависят от автомобиля. Все условия сообщаются прозрачно до подтверждения.",
      },
    ],
  },
  form: {
    eyebrow: "Запрос на бронирование",
    title: "Запрос на бронирование",
    sub: "Расскажите, что и когда хотите водить. Мы ответим с наличием, точной ценой и требованиями.",
    name: "Полное имя",
    email: "Эл. почта",
    phone: "Телефон",
    method: "Предпочтительный способ связи",
    methodWhatsapp: "WhatsApp",
    methodCall: "Телефонный звонок",
    methodEmail: "Эл. почта",
    vehicle: "Интересующий автомобиль",
    vehicleAny: "Любой / нужен совет",
    pickup: "Дата получения",
    return: "Дата возврата",
    handover: "Получение или доставка",
    handoverPickup: "Заберу сам(а)",
    handoverDelivery: "Доставка (отель / резиденция / аэропорт)",
    message: "Дополнительное сообщение",
    messagePh: "Рейс, адрес доставки, вопросы…",
    submit: "Отправить запрос",
    sending: "Отправка…",
    success: "Ваш запрос готов — WhatsApp открылся со всеми данными. Просто нажмите «Отправить», и мы скоро ответим.",
    whatsappNote: "При отправке откроется WhatsApp с вашим запросом — самый быстрый способ связаться с нами.",
    error: "Не удалось отправить запрос. Попробуйте ещё раз или напишите нам в WhatsApp.",
    errRequired: "Обязательное поле",
    errEmail: "Введите корректный email",
    errDates: "Дата возврата не может быть раньше даты получения",
  },
  contact: {
    eyebrow: "Контакты",
    title: "Свяжитесь с нами напрямую",
    text: "Самый быстрый способ узнать наличие и цены. Отвечаем в WhatsApp и по телефону.",
    whatsapp: "Написать в WhatsApp",
    whatsappAlt: "WhatsApp — вторая линия",
    callUs: "Позвонить",
    uae: "ОАЭ",
    germany: "Германия",
    uaeNote: "Телефонные звонки",
    germanyNote: "WhatsApp и звонки",
    copy: "Копировать",
    copied: "Скопировано",
  },
  floating: {
    open: "Контакты",
    whatsapp: "WhatsApp",
    whatsappAlt: "WhatsApp (вторая линия)",
    callUae: "Позвонить в ОАЭ",
    callDe: "Позвонить в Германию",
  },
  footer: {
    desc: "Премиальная аренда авто в Дубае — от повседневных поездок до ярких впечатлений.",
    fleetTitle: "Автопарк",
    contactTitle: "Контакты",
    legalTitle: "Правовая информация",
    socialTitle: "Мы в соцсетях",
    privacy: "Политика конфиденциальности",
    terms: "Условия использования",
    cookies: "Настройки cookie",
    impressum: "Правовая информация",
    rights: "Все права защищены.",
    socialPlaceholder: "Официальные профили скоро появятся",
  },
  cookies: {
    text: "Мы используем только необходимое хранилище для запоминания языка и аналитику для улучшения сайта. Рекламные cookie не используются.",
    accept: "Принять",
    decline: "Отклонить",
  },
  legal: {
    privacyTitle: "Политика конфиденциальности",
    termsTitle: "Условия использования",
    impressumTitle: "Правовая информация",
    backHome: "На главную",
    impressumNote: "Правовая информация о сайте A&A MOTORS. Поля с пометкой [будет предоставлено] будут заполнены после получения официальных регистрационных документов.",
    impressumFields: [
      "Бренд / название компании: A&A MOTORS",
      "Основатели / законные представители: Abadellh Aiouze · Amin Schmidt",
      "Местоположение: Дубай, ОАЭ — полный юридический адрес: [будет предоставлен]",
      "Номер торговой лицензии: [будет предоставлен]",
      "НДС / TRN: [будет предоставлен]",
      "Ответственные за контент: Abadellh Aiouze · Amin Schmidt",
    ],
    privacySections: [
      { h: "Какие данные мы собираем", p: "При отправке запроса мы обрабатываем указанные вами данные — имя, email, телефон, желаемый автомобиль и даты аренды — исключительно для ответа на запрос." },
      { h: "Как мы их используем", p: "Ваши данные используются только для обработки запроса и, при бронировании, для подготовки договора аренды. Мы не продаём и не передаём данные третьим лицам для маркетинга." },
      { h: "Хранение", p: "Запросы хранятся безопасно и только столько, сколько необходимо для обработки обращения и выполнения юридических обязательств." },
      { h: "Ваши права", p: "Вы можете в любой момент запросить доступ, исправление или удаление ваших данных — через WhatsApp или по телефону." },
    ],
    termsSections: [
      { h: "Общие положения", p: "Эти условия регулируют использование сайта A&A MOTORS. Автомобили, наличие и цены являются примерным контентом до подтверждения в индивидуальном договоре аренды." },
      { h: "Запросы и бронирования", p: "Отправка запроса не создаёт бронирование. Договор аренды заключается только после подтверждения наличия, цены и требований нашей командой." },
      { h: "Автомобили и цены", p: "Показанные автомобили, характеристики и цены носят ознакомительный характер. Итоговые условия — депозит, страховка, пробег и сборы Salik — сообщаются до бронирования." },
      { h: "Ответственность", p: "Мы стремимся к точности, но не гарантируем полноту и актуальность всего контента сайта в любой момент времени." },
    ],
  },
  admin: {
    login: "Вход для администратора",
    email: "Email",
    password: "Пароль",
    signIn: "Войти",
    signingIn: "Вход…",
    loginError: "Неверные данные или слишком много попыток.",
    dashboard: "Панель автопарка",
    vehicles: "Автомобили",
    enquiries: "Запросы",
    logout: "Выйти",
    addVehicle: "Добавить авто",
    edit: "Изменить",
    del: "Удалить",
    save: "Сохранить",
    cancel: "Отмена",
    name: "Название",
    category: "Категория",
    price: "Цена / день (AED, пусто = по запросу)",
    seats: "Мест",
    transmission: "Коробка",
    availability: "Наличие",
    noDeposit: "Без депозита",
    image: "URL изображения",
    featured: "Рекомендуемый",
    status: "Статус",
    empty: "Запросов пока нет.",
    confirmDelete: "Удалить этот автомобиль?",
    dates: "Даты",
    message: "Сообщение",
    back: "Вернуться на сайт",
    vehicleSaved: "Автомобиль сохранён",
    vehicleDeleted: "Автомобиль удалён",
    statusUpdated: "Статус обновлён",
    newVehicle: "Новый автомобиль",
    editVehicle: "Редактировать автомобиль",
  },
};
